import React, { useEffect, useState } from "react";
import Sap1 from "../assets/img/images/sap2.jpg"; // Local image
import Sap2 from "../assets/img/images/sap3.png";
import Sap3 from "../assets/img/images/sap 1.png";

const Sap = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: isMobile ? "30px 15px" : "60px 20px",
      backgroundColor: "#f9fafb",
      fontFamily: "'Poppins', sans-serif",
    },
    heading: {
      fontWeight: "bold",
      textAlign: "center",
      marginTop: "3.2rem",
      marginBottom: "20px",
      color: "#7620ff",
    },
    timeline: {
      position: "relative",
      maxWidth: "1000px",
      width: "100%",
    },
    line: {
      content: "''",
      position: "absolute",
      left: isMobile ? "10px" : "50%",
      top: 0,
      bottom: 0,
      width: "4px",
      backgroundColor: "#cbd5e1",
      transform: isMobile ? "none" : "translateX(-50%)",
    },
    entry: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "60px",
      position: "relative",
      paddingLeft: isMobile ? "30px" : "0",
    },
    content: {
      backgroundColor: "#ffffff",
      padding: "20px",
      borderRadius: "12px",
      width: isMobile ? "100%" : "45%",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    },
 
    dot: {
      position: "absolute",
      left: isMobile ? "0px" : "50%",
      top: "15px",
      width: "16px",
      height: "16px",
      backgroundColor: "#3b82f6",
      borderRadius: "50%",
      border: "4px solid white",
      transform: isMobile ? "none" : "translateX(-50%)",
      zIndex: 2,
    },
    title: {
      fontWeight: "bold",
      color: "#fdba00", // main section titles in purple
      marginBottom: "10px",
    },
    text: {
      color: "#555",
      lineHeight: "1.6",
    },
    bulletList: {
      listStyleType: "disc",
      paddingLeft: "20px",
      color: "#444",
    },
    image: {
      width: isMobile ? "100%" : "45%",
      height: "auto",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      objectFit: "cover",
    },
  };

  const services = [
    {
      title: "About SAP",
      description:
        "SAP (Systems, Applications, and Products) is a German company and a leading provider of enterprise application software, particularly in the areas of ERP and related technologies.",
      image: Sap1,
    },
    {
      title: "SAP ERP",
      description:
        "The core of SAP's offerings is its ERP system, which helps companies centralize data and automate business processes, leading to improved efficiency and accelerated workflows.",
    },
    {
      title: "SAP S/4HANA",
      description:
        "SAP S/4HANA is the latest generation of SAP's ERP system, built on the SAP HANA in-memory platform, offering real-time processing and intelligent technologies like AI and machine learning.",
      image: Sap2,
    },
    {
      title: "SAP Business Technology Platform (BTP)",
      description:
        "BTP is a PaaS offering services like database management, AI, analytics, and application development, all on a unified platform.",
    },
    {
      title: "Other Modules",
      description:
        "SAP offers additional modules for specific business areas such as SCM, HCM, and CRM, providing flexible integration across enterprise needs.",
      image: Sap3,
    },
    {
      title: "Key Benefits",
      description: (
        <ul style={styles.bulletList}>
          <li><strong style={{ color: '#1e40af' }}>Centralized Data Management:</strong> SAP systems provide a single source of truth.</li>
          <li><strong style={{ color: '#0d9488' }}>Streamlined Business Processes:</strong> SAP automates and integrates business operations.</li>
          <li><strong style={{ color: '#9333ea' }}>Improved Decision Making:</strong> Real-time data helps in faster decisions.</li>
          <li><strong style={{ color: '#be123c' }}>Enhanced Collaboration:</strong> Cloud-based tools improve cross-team collaboration.</li>
        </ul>
      ),
    },
    {
      title: "SAP's Role in Digital Transformation",
      description:
        "SAP empowers digital transformation by providing advanced technologies and integrated solutions for evolving business landscapes.",
    },
  ];

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Explore SAP Technologies</h1>

      <div style={styles.timeline}>
        <div style={styles.line}></div>
        {services.map((service, index) => {
          const isEven = index % 2 === 0;

          const textContent = (
            <div
              style={{
                ...styles.content,
                borderLeft: `5px solid ${isEven ? "#3b82f6" : "#9333ea"}`,
              }}
              onMouseEnter={(e) =>
                Object.assign(e.currentTarget.style, styles.contentHover)
              }
              onMouseLeave={(e) =>
                Object.assign(e.currentTarget.style, styles.content)
              }
            >
              <h3
                style={{
                  ...styles.title,
                  color: index % 2 === 0 ? "#fdba00" : "#fdba00",
                }}
              >
                {service.title}
              </h3>
              <div style={styles.text}>{service.description}</div>
            </div>
          );

          const imageContent = service.image ? (
            <img
              src={service.image}
              alt={service.title}
              style={styles.image}
            />
          ) : (
            <div style={{ width: isMobile ? "100%" : "45%" }}></div>
          );

          return (
            <div
              key={index}
              style={{
                ...styles.entry,
                flexDirection: isMobile
                  ? "column"
                  : isEven
                  ? "row"
                  : "row-reverse",
              }}
            >
              <div style={styles.dot}></div>
              {isEven ? (
                <>
                  {textContent}
                  {imageContent}
                </>
              ) : (
                <>
                  {imageContent}
                  {textContent}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sap;
